import { methodRows } from "@/mocks/statusAndSecurity";
import SectionHeading from "./SectionHeading";

export default function CompareSection() {
  return (
    <section id="compare" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="访问方式对比"
          title="五种访问方式，分别适合什么情况"
          desc="网页版、APP、备用线路各有取舍。下面按速度、稳定性、使用门槛与更新时效做了对比，你可以按自己的使用场景挑选。"
        />

        <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[760px] border-collapse text-sm">
              <thead>
                <tr className="bg-secondary-900 text-background-50">
                  <th className="text-left font-medium px-4 py-3.5 whitespace-nowrap">访问方式</th>
                  <th className="text-left font-medium px-4 py-3.5 whitespace-nowrap">速度</th>
                  <th className="text-left font-medium px-4 py-3.5 whitespace-nowrap">稳定性</th>
                  <th className="text-left font-medium px-4 py-3.5 whitespace-nowrap">使用门槛</th>
                  <th className="text-left font-medium px-4 py-3.5 whitespace-nowrap">更新时效</th>
                  <th className="text-left font-medium px-4 py-3.5">适合场景</th>
                </tr>
              </thead>
              <tbody>
                {methodRows.map((row, i) => (
                  <tr
                    key={row.id}
                    className={`border-t border-background-200 ${i % 2 === 1 ? "bg-background-50" : "bg-background-100/60"}`}
                  >
                    <td className="px-4 py-3.5">
                      <span className="inline-flex items-center gap-2 font-medium text-foreground-950 whitespace-nowrap">
                        {i === 0 ? <i className="ri-star-fill text-accent-500"></i> : null}
                        {row.method}
                      </span>
                    </td>
                    <td className="px-4 py-3.5 text-foreground-700 whitespace-nowrap">{row.speed}</td>
                    <td className="px-4 py-3.5 whitespace-nowrap">
                      <span className="px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                        {row.stability}
                      </span>
                    </td>
                    <td className="px-4 py-3.5 text-foreground-700 whitespace-nowrap">{row.door}</td>
                    <td className="px-4 py-3.5 text-foreground-700 whitespace-nowrap">{row.freshness}</td>
                    <td className="px-4 py-3.5 text-foreground-600">{row.suitable}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex items-center gap-2 text-primary-600">
              <i className="ri-rocket-2-line text-lg"></i>
              <h3 className="font-heading font-semibold text-foreground-950">图省事</h3>
            </div>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">直接用主线路网页版，打开即用，不用装任何东西。</p>
          </div>
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex items-center gap-2 text-accent-600">
              <i className="ri-smartphone-line text-lg"></i>
              <h3 className="font-heading font-semibold text-foreground-950">手机上常看</h3>
            </div>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">选移动优化线路，或在可用地址页获取APP，弱网下更顺。</p>
          </div>
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex items-center gap-2 text-secondary-600">
              <i className="ri-shield-line text-lg"></i>
              <h3 className="font-heading font-semibold text-foreground-950">求稳妥</h3>
            </div>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">同时收藏一条主线路和一条备用线路，出问题时随时切换。</p>
          </div>
        </div>
      </div>
    </section>
  );
}